import * as React from 'react';

import FileText32 from './FileText32';

export const fileText32 = () => <FileText32 />;

export default {
    title: 'Icon/Content/FileText32',
    component: FileText32,
    parameters: {
        notes: "`import FileText32 from 'box-ui-elements/es/icon/content/FileText32';`",
    },
};
